// src/pages/CalculatorPage.jsx
import React, { useState } from 'react';
import { Box, Container, Typography, Stepper, Step, StepLabel, Paper, Button, Divider } from '@mui/material';

// Placeholder imports for subcomponents
import AccountSelector from '../../components/AccountSelector';
import AccountSelectorContainer from '../../components/AccountSelectorContainer';
// import FileUploader from '../components/FileUploader';
// import EMFOptions from '../components/EMFOptions';
// import ClaimsEditor from '../components/ClaimsEditor';
// import EMFResults from '../components/EMFResults';

const steps = [
  'Select Account(s)',
  'Upload Files',
  'Choose EMF Options',
  'Edit Claims',
  'Calculate & View Results'
];

export default function CalculatorPage() {
  const [activeStep, setActiveStep] = useState(0);
  const [selectedAccounts, setSelectedAccounts] = useState([]);

  return (
    <Container maxWidth="md" sx={{ py: 5 }}>
      <Paper elevation={3} sx={{ p: 4, borderRadius: 4 }}>
        <Typography variant="h4" align="center" gutterBottom>
          Experience Modification Factor Calculator
        </Typography>
        <Divider sx={{ mb: 3 }} />
        
        {/* Stepper to show user progress */}
        <Stepper activeStep={activeStep} alternativeLabel sx={{ mb: 4 }}>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
        
        {/* Switch based on active step */}
        {activeStep === 0 && (
          <Box>
            <AccountSelectorContainer
            selected={selectedAccounts}
            setSelected={setSelectedAccounts}
            />
            <Button sx={{ mt: 2 }} variant="contained" onClick={() => setActiveStep(1)}>
              Next
            </Button>
          </Box>
        )}
        {activeStep === 1 && (
          <Box>
            {/* <FileUploader /> */}
            <Typography>File Uploader goes here.</Typography>
            <Button sx={{ mt: 2, mr: 1 }} onClick={() => setActiveStep(0)}>Back</Button>
            <Button sx={{ mt: 2 }} variant="contained" onClick={() => setActiveStep(2)}>Next</Button>
          </Box>
        )}
        {activeStep === 2 && (
          <Box>
            {/* <EMFOptions /> */}
            <Typography>EMF Options go here.</Typography>
            <Button sx={{ mt: 2, mr: 1 }} onClick={() => setActiveStep(1)}>Back</Button>
            <Button sx={{ mt: 2 }} variant="contained" onClick={() => setActiveStep(3)}>Next</Button>
          </Box>
        )}
        {activeStep === 3 && (
          <Box>
            {/* <ClaimsEditor /> */}
            <Typography>Claims Editor goes here.</Typography>
            <Button sx={{ mt: 2, mr: 1 }} onClick={() => setActiveStep(2)}>Back</Button>
            <Button sx={{ mt: 2 }} variant="contained" onClick={() => setActiveStep(4)}>Calculate</Button>
          </Box>
        )}
        {activeStep === 4 && (
          <Box>
            {/* <EMFResults /> */}
            <Typography>EMF Results go here.</Typography>
            <Button sx={{ mt: 2, mr: 1 }} onClick={() => setActiveStep(3)}>Back</Button>
            <Button sx={{ mt: 2 }} variant="contained">Finish</Button>
          </Box>
        )}
      </Paper>
    </Container>
  );
}
